import { print, print2 } from "@/components/PrintTemplate/index.js";
import washing from "@/assets/washlabel/washing.png";
import spindry from "@/assets/washlabel/spindry.png";
import rinse from "@/assets/washlabel/rinse.png";
import ironing from "@/assets/washlabel/ironing.png";
import dryclean from "@/assets/washlabel/dryclean.png";

import {
  printQueryByCode,
  getPkgTemplate,
  printQueryById,
} from "@/apis/inHouse";
import { Message } from "element-ui";

let washTemplateJson =
"{\"panels\":[{\"index\":0,\"height\":208,\"width\":60,\"paperHeader\":0,\"paperFooter\":589.6062992125985,\"printElements\":[{\"options\":{\"left\":0,\"top\":0,\"height\":6,\"width\":80,\"fontSize\":\"6\",\"fontWeight\":\"lighter \",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"6\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"输入文本\",\"title\":\" -\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":10.5,\"height\":44,\"width\":157.5,\"fontSize\":\"10\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"13\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"180\",\"testData\":\"输入文本\",\"title\":\"3.生成り、淡色製品には蛍光増白剤が入っていない洗剤をご使用下さい。\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":60,\"height\":16.5,\"width\":157.5,\"fontSize\":\"10\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"13\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"180\",\"testData\":\"输入文本\",\"title\":\"2.洗濯後多少の縮みがあります。\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":84,\"height\":80,\"width\":157.5,\"fontSize\":\"10\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"13\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"180\",\"testData\":\"输入文本\",\"title\":\"1.色物の場合は、洗濯時に多少色落ちすることがありますので、他の洗濯物との混入はお避け下さい。また、汗や湿った状態での摩擦により、色落ちが生じる恐れがあります。\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":171,\"height\":16,\"width\":157.5,\"fontSize\":\"14\",\"fontWeight\":\"700\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"15\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"180\",\"testData\":\"输入文本\",\"title\":\"注意事項\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":41,\"top\":195,\"height\":84,\"width\":84,\"fontSize\":\"16\",\"fontWeight\":\"lighter \",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"50\",\"textType\":\"text\",\"textAlign\":\"center\",\"hideTitle\":true,\"transform\":\"180\",\"testData\":\"LOGO\",\"field\":\"logo\"},\"printElementType\":{\"title\":\"文本\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":367.5,\"height\":13,\"width\":157.5,\"fontSize\":\"10\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"12\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"商品番号: S22050702000016\",\"field\":\"shopProductSku\",\"title\":\"商品番号\"},\"printElementType\":{\"title\":\"文本\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":384,\"height\":13,\"width\":157.5,\"fontSize\":\"11\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"12\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"M\",\"field\":\"productPropertiesNameParse\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":402,\"height\":49.5,\"width\":157.5,\"fontSize\":\"11\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"12\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％\",\"title\":\"\",\"field\":\"materialInfoJa\"},\"printElementType\":{\"title\":\"文本\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":457.5,\"height\":20,\"width\":157.5,\"fontSize\":\"14\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"20\",\"textType\":\"text\",\"textAlign\":\"center\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"图标图标图标图标图标\",\"title\":\"\",\"field\":\"washpic\"},\"printElementType\":{\"title\":\"文本\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":484.5,\"height\":18,\"width\":157.5,\"fontSize\":\"12\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"13\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"公司名字\",\"field\":\"companyName\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":510,\"height\":52.5,\"width\":157.5,\"fontSize\":\"12\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"13\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"公司地址信息公司地址信息公司地址信息公司地址信息公司地址信息公司地址信息公司地址信息\",\"field\":\"companyAddress\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":0,\"top\":571.5,\"height\":4,\"width\":80,\"fontSize\":\"4\",\"fontWeight\":\"lighter \",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"4\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":false,\"transform\":\"0\",\"testData\":\"输入文本\",\"title\":\"-\"},\"printElementType\":{\"title\":\"文本\",\"type\":\"text\"}}],\"paperNumberLeft\":140,\"paperNumberTop\":567,\"paperNumberDisabled\":true}]}"

let washTemplateJson_KR = 
"{\"panels\":[{\"index\":0,\"height\":208,\"width\":60,\"paperHeader\":0,\"paperFooter\":589.6062992125985,\"printElements\":[{\"options\":{\"left\":0,\"top\":0,\"height\":6,\"width\":80,\"fontSize\":\"6\",\"fontWeight\":\"lighter \",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"6\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"输入文本\",\"title\":\" -\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":10.5,\"height\":44,\"width\":157.5,\"fontSize\":\"10\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"13\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"180\",\"testData\":\"输入文本\",\"title\":\"3. 생성되거나 연한색 제품에는 형광증백제가 들어있지 않은 세제를 사용하십시오.\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":60,\"height\":16.5,\"width\":157.5,\"fontSize\":\"10\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"13\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"180\",\"testData\":\"输入文本\",\"title\":\"2.세탁 후 약간의 수축이 있습니다.\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":84,\"height\":80,\"width\":157.5,\"fontSize\":\"10\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"13\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"180\",\"testData\":\"输入文本\",\"title\":\"1.색상의 경우 세탁시 다소 물빠짐이 있을 수 있으니 다른 세탁물과의 혼입을 피해주십시오.또한 땀이나 습한 상태에서의 마찰로 인해 물빠짐이 발생할 수 있습니다.\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":171,\"height\":16,\"width\":157.5,\"fontSize\":\"14\",\"fontWeight\":\"700\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"15\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"180\",\"testData\":\"输入文本\",\"title\":\"주의사항\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":41,\"top\":195,\"height\":84,\"width\":84,\"fontSize\":\"16\",\"fontWeight\":\"lighter \",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"50\",\"textType\":\"text\",\"textAlign\":\"center\",\"hideTitle\":true,\"transform\":\"180\",\"testData\":\"LOGO\",\"field\":\"logo\"},\"printElementType\":{\"title\":\"文本\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":367.5,\"height\":13,\"width\":157.5,\"fontSize\":\"10\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"12\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"商品番号: S22050702000016\",\"field\":\"shopProductSku\",\"title\":\"商品番号\"},\"printElementType\":{\"title\":\"文本\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":384,\"height\":13,\"width\":157.5,\"fontSize\":\"11\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"12\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"M\",\"field\":\"productPropertiesNameParse\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":402,\"height\":49.5,\"width\":157.5,\"fontSize\":\"11\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"12\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％棉100％\",\"title\":\"\",\"field\":\"materialInfoJa\"},\"printElementType\":{\"title\":\"文本\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":457.5,\"height\":20,\"width\":157.5,\"fontSize\":\"14\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"20\",\"textType\":\"text\",\"textAlign\":\"center\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"图标图标图标图标图标\",\"title\":\"\",\"field\":\"washpic\"},\"printElementType\":{\"title\":\"文本\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":484.5,\"height\":18,\"width\":157.5,\"fontSize\":\"12\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"13\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"公司名字\",\"field\":\"companyName\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":4.5,\"top\":510,\"height\":52.5,\"width\":157.5,\"fontSize\":\"12\",\"fontWeight\":\"600\",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"13\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":true,\"transform\":\"0\",\"testData\":\"公司地址信息公司地址信息公司地址信息公司地址信息公司地址信息公司地址信息公司地址信息\",\"field\":\"companyAddress\"},\"printElementType\":{\"title\":\"长文\",\"type\":\"text\"}},{\"options\":{\"left\":0,\"top\":571.5,\"height\":4,\"width\":80,\"fontSize\":\"4\",\"fontWeight\":\"lighter \",\"fontFamily\":\"Microsoft Yahei\",\"color\":\"#000\",\"lineHeight\":\"4\",\"textType\":\"text\",\"textAlign\":\"left\",\"hideTitle\":false,\"transform\":\"0\",\"testData\":\"输入文本\",\"title\":\"-\"},\"printElementType\":{\"title\":\"文本\",\"type\":\"text\"}}],\"paperNumberLeft\":140,\"paperNumberTop\":567,\"paperNumberDisabled\":true}]}"

// 库位模版正常 8cm
const regionTemplate8cm =
  '{"panels":[{"index":0,"height":59,"width":100,"paperHeader":0,"paperFooter":167.244094488189,"printElements":[{"options":{"left":50,"top":26.5,"height":80,"width":180,"fontSize":"28","fontWeight":"bold ","fontFamily":"Microsoft Yahei","color":"#000","lineHeight":"50","textType":"barcode","textAlign":"center","hideTitle":false,"transform":"0","testData":"A1-Z9-01-99","field":"gridCode"},"printElementType":{"title":"文本","type":"text"}}],"paperNumberLeft":253,"paperNumberTop":145,"paperNumberDisabled":true}]}';
// 库位模版正常
  const bigRegionTemplate =
  '{"panels":[{"index":0,"height":59,"width":100,"paperHeader":0,"paperFooter":167.244094488189,"printElements":[{"options":{"left":15,"top":26.5,"height":80,"width":252,"fontSize":"35","fontWeight":"bold ","fontFamily":"Microsoft Yahei","color":"#000","lineHeight":"50","textType":"barcode","textAlign":"center","hideTitle":false,"transform":"0","testData":"A1-Z9-01-99","field":"gridCode"},"printElementType":{"title":"文本","type":"text"}}],"paperNumberLeft":253,"paperNumberTop":145,"paperNumberDisabled":true}]}';
  const normalRegionTemplate = '{"panels":[{"index":0,"height":59,"width":100,"paperHeader":0,"paperFooter":167.244094488189,"printElements":[{"options":{"left":15,"top":46.5,"height":57,"width":252,"fontSize":"35","fontWeight":"lighter ","fontFamily":"Microsoft Yahei","color":"#000","lineHeight":"30","textType":"barcode","textAlign":"left","hideTitle":false,"transform":"0","testData":"A1-Z9-01-99","field":"gridCode"},"printElementType":{"title":"文本","type":"text"}}],"paperNumberLeft":253,"paperNumberTop":145,"paperNumberDisabled":true}]}';

  const overseasBoxCodeTemplate = '{"panels":[{"index":0,"height":59,"width":100,"paperHeader":0,"paperFooter":167.244094488189,"printElements":[{"options":{"left":15,"top":46.5,"height":70,"width":252,"fontSize":"16","fontWeight":"bold ","fontFamily":"Microsoft Yahei","color":"#000","lineHeight":"30","textType":"barcode","textAlign":"center","hideTitle":false,"transform":"0","testData":"A1-Z9-01-99","field":"gridCode"},"printElementType":{"title":"文本","type":"text"}}],"paperNumberLeft":253,"paperNumberTop":145,"paperNumberDisabled":true}]}';

let templatePrintByCode = function (labelTemplateId, arr) {
  printQueryByCode({ templateCode: labelTemplateId }).then(({ code, data }) => {
    if (code === 0) {
      if (!data || !data.templateJson) {
        Message.warning("无打印模板，请先添加模板");
        return false;
      }
      print2(JSON.parse(data.templateJson), arr);
    }
  });
};

let templatePrintById = function (id, arr) {
  console.log(arr)
  if (!id || !arr) {
    Message.warning("请选择模板ID");
    return false;
  }
  printQueryById({ id: id }).then(({ code, data }) => {
    if (code === 0) {
      if (!data.templateJson) {
        Message.warning("无打印模板，请先添加模板");
        return false;
      }
      print2(JSON.parse(data.templateJson), arr);
    }
  });
};

let templatePrintByPkg = function (arr) {
  getPkgTemplate().then(({ code, data }) => {
    if (code === 0) {
      if (!data) {
        Message.warning("无打印模板，请先添加模板");
        return false;
      }
      print2(JSON.parse(data.templateJson), arr);
    }
  });
};

// 1  放大 2 8cm 3原始版本
let templatePrintByGridcode = function (arr, templatePrint = '1') {
  // toPDF(JSON.parse(regionTemplate), arr)
  const template = {
    '1': bigRegionTemplate,
    '2': regionTemplate8cm,
    '3': normalRegionTemplate,
    '4': overseasBoxCodeTemplate
  }
  print2(JSON.parse(template[templatePrint]), arr);

  // const formData = new FormData();
  // formData.append("copies", 1);
  // formData.append("duplex", false);
  // formData.append(
  //   "url",
  //   "https://theckbstest-oss.theckbs.com/null84fbabfda9c.pdf"
  // );
  // formData.append("paperSize", "A4");
  // axios({
  //   method: "post",
  //   url: "http://127.0.0.1:20730/printPdf?_m=" + Math.random(),
  //   data: formData,
  // }).then((res) => {
  //   console.log(res);
  // });
};

let templatePrintByJSON = function (temJSON, arr) {
  print2(JSON.parse(temJSON), arr);
};

let printContentList = [
  {
    value: "overseasProductSku",
    label: "海外仓SKU番号",
    placeholder: "S22050702000016",
  },
  {
    value: "overseasProductSkuCode",
    label: "海外仓SKU编码",
    placeholder: "S22050702000016",
  },
  {
    value: "pkgCode",
    label: "批次包编码",
    placeholder: "2206161537254575089000000",
  },
  {
    value: "amount",
    label: "批次数量",
    placeholder: "1",
  },
  {
    value: "productName",
    label: "商品名称",
    placeholder: "商品名称",
  },
  {
    value: "ingredientType",
    label: "辅料类型",
    placeholder: "辅料类型",
  },
  {
    value: "additionalListNames",
    label: "质检要求-名字",
    placeholder: "质检要求-名字",
  },
  {
    value: "additionWithIngredientGrid",
    label: "质检要求-库位",
    placeholder: "质检要求-库位",
  },
  {
    value: "additionOnlyNames",
    label: "质检要求",
    placeholder: "质检要求",
  },
  {
    value: "unificationCustomerFullName",
    label: "客户名称",
    placeholder: "客户名称",
  },
   {
    value: "customerName",
    label: "用户名",
    placeholder: "用户名",
  },
  {
    value: "customerShopName",
    label: "客户店铺名称",
    placeholder: "客户店铺名称",
  },
  {
    value: "productProp",
    label: "颜色尺码",
    placeholder: "颜色尺码",
  },
  {
    value: "shopProductSku",
    label: "仓库SKU",
    placeholder: "S22050702000016",
  },
  {
    value: "productSku",
    label: "商品SKU",
    placeholder: "2ab2cb7de702b461651728b120c5b02b",
  },
  {
    value: "gridCode",
    label: "货格码",
    placeholder: "A1-Z9-01-99",
  },
  // {
  //   value: "companyAddress",
  //   label: "水洗标公司地址信息",
  //   placeholder: "公司地址信息",
  // },
  // {
  //   value: "companyName",
  //   label: "公司名字",
  //   placeholder: "公司名字",
  // },
  // {
  //   value: "productPropertiesNameParse",
  //   label: "尺码",
  //   placeholder: "M",
  // },
  // {
  //   value: "materialInfoJa",
  //   label: "材质",
  //   placeholder: "棉",
  // },
  {
    value: "amazonFnsku",
    label: "FNSKU",
    placeholder: "123456",
  },
  {
    value: "amazonProductTitle",
    label: "Amazon商品名",
    placeholder: "Amazon商品名",
  },
  {
    value: "systemSource",
    label: "业务类型",
    placeholder: "D2C/B2B",
  },
  {
    value: "specialFlag",
    label: "特殊质检要求",
    placeholder: "特",
  },
  {
    value: "ingredientsFlag",
    label: "辅料",
    placeholder: "辅",
  },
  {
    value: "combinationProductItemFlag",
    label: "组合商品",
    placeholder: "组",
  },
  {
    value: "customerTag",
    label: "重点客户",
    placeholder: "重",
  },
  {
    value: "crossDockingFlag",
    label: "是否可越库",
    placeholder: "越",
  },
  {
    value: "customerTagName",
    label: "标识名称",
    placeholder: "标签名称",
  },
  {
    value: undefined,
    label: "输入文本",
    placeholder: "输入文本",
  },
  {
    value: 'pkgCustomerProductSku',
    label:'客户自定义sku',
    placeholder:"客户自定义sku"
  },
  {
    value: 'washedlabelSpecification',
    label:'水洗标规格',
    placeholder:"水洗标规格"
  }
];

let washlabelImages = [
  {
    options: {
      left: 6,
      top: 458,
      height: 20,
      width:29,
      src: washing,
    },
    printElementType: {
      title: "图片",
      type: "image",
    },
  },
  {
    options: {
      left: 38,
      top: 458,
      height: 20,
      width:25,
      src: spindry,
    },
    printElementType: {
      title: "图片",
      type: "image",
    },
  },
  {
    options: {
      left: 70,
      top: 458,
      height: 20,
      width:28,
      src: ironing,
    },
    printElementType: {
      title: "图片",
      type: "image",
    },
  },
  {
    options: {
      left: 102,
      top: 458,
      height: 20,
      width:22,
      src: rinse,
    },
    printElementType: {
      title: "图片",
      type: "image",
    },
  },
  {
    options: {
      left: 125,
      top: 458,
      height: 20,
      width:24,
      src: dryclean,
    },
    printElementType: {
      title: "图片",
      type: "image",
    },
  },
];

export {
  templatePrintByCode,
  templatePrintByPkg,
  templatePrintByGridcode,
  templatePrintById,
  templatePrintByJSON,
  printContentList,
  washlabelImages,
  washTemplateJson,
};
